//////////////////////////////////////////////////////////
//                                                      //   
//  PARA TODOS OS USUÁRIOS:                             //   
//                                                      //   
//  APARECE COMO ABA LATERAL ESQUERDA APÓS              //
//  O CLICK DO BOTÃO DE FILTRO NA PÁGINA HOME           //   
//                                                      //   
//  FUNCIONALIDADE: REALIZAR O FILTRO DE PRODUTOS       //    
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/pages/home.js                                      //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import { Dropdown } from 'semantic-ui-react'

import jQuery from 'jquery'

function Filtro(props) {

    const grupos = props.props.map(block => ({
        key: block,
        text: block,
        value: block,
      }))    
    
    
    async function setQuery() {  // FUNÇÃO PARA REALIZAR O FILTRO
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO 'Submit' DESSE COMPONENTE

        window.stop()  // PARA QUERIES ANTERIORES

        var grupo = []
        for (var i=1; i < jQuery('.ui').length; i++){  // PEGA AS INFORMAÇÕES DEFINIDAS NO FILTRO
            grupo.push(jQuery('.ui')[i].innerText)
        }
    
        var preco_minimo = jQuery('.tamanho-filtro')[1].value
        var preco_maximo = jQuery('.tamanho-filtro')[2].value
        var ordem = jQuery('.tamanho-filtro')[3].value

        var dict_ordem = {
            '---------': '[Grupo_Imaginarium].[dbo].[PRODUTOS].DATA_CADASTRAMENTO ',
            'Maior Preço': '[Grupo_Imaginarium].[dbo].[PRODUTOS_PRECOS].PRECO1 DESC ',
            'Menor Preço': '[Grupo_Imaginarium].[dbo].[PRODUTOS_PRECOS].PRECO1 ',
            'Lançamentos': '[Grupo_Imaginarium].[dbo].[PRODUTOS].DATA_CADASTRAMENTO ',
            // 'Populares': '[Grupo_Imaginarium].[dbo].[PRODUTOS_PRECOS].PRECO1 ',
            // 'Promoções': '[Grupo_Imaginarium].[dbo].[PRODUTOS_PRECOS].PRECO1 ',
        }

        console.log(ordem)
        console.log(dict_ordem[ordem])

        var dict_filtro = {'grupo': grupo.toString(), 'preco_minimo': preco_minimo, 'preco_maximo': preco_maximo, 'ordem': dict_ordem[ordem]}  // DEFINE O DICIONÁRIO COM AS INFORMAÇÕES

        jQuery('#loader').removeClass('d-none') // FAZ O LOADER APARECER
        close_filtro() // FECHA A ABA LATERAL ESQUERDA DE FILTRO
    
        var texto = document.getElementById('filtro_por_texto').value  // PEGA TAMBÉM O VALOR DO FILTRO GERAL

        var inicio = props.callback(JSON.stringify(dict_filtro), texto)  // E CHAMA A FUNÇÃO 'search_produtos' DO ARQUIVO 'frontend/src/pages/home.js'
        console.log(inicio)
    };      


    function close_filtro(){  // FUNÇÃO PARA FECHAR A ABA LATERAL ESQUERDA DE FILTRO
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO DE CLOSE DA ABA LATERAL ESQUERDA
        // FUNÇÃO CHAMADA NO FINAL DA DEFINIÇÃO DOS FILTROS NA FUNÇÃO 'setQuery' DESSE COMPONENTE

        document.getElementById("filtro").classList.add('d-none')
      }


    return(  // RENDERIZA O COMPONENTE

    <div class="px-0 filtro-form d-none" id="filtro">
        <div class="row col col-12 mx-0 height-header-carrinho">
            <div class="row col-9 col px-0 mx-0">
                <h3 class="mt-3 mb-2 verde px-2 montserrat fonte-x-large">Filtros</h3>
            </div>

            <div class="col-3 pl-0 mt-2 mb-2">
                <button className="cancel-pqn my-1 mx-1 pull-right" onClick={close_filtro}>
                    <i className="fa fa-close"></i>
                </button>    
            </div>
        </div>        

        {/* TODO: Criar aqui div pro filtro dos favoritos com checkbox */}

        <div class='body-carrinho px-3 py-4'>
            <div class='mb-3'>
                <h5 class='montserrat verde'>Grupo Produto</h5>
                <div class="d-flex align-items-end justify-content-end">
                    <Dropdown 
                    fluid
                    multiple
                    search
                    selection
                    className='border-redonda tamanho-filtro mult-select'
                    options={grupos}
                    />
                </div>
            </div>

            <div class='mb-3'>
                <h5 class='montserrat verde'>Preço Mínimo</h5>
                    <input type="number" min='0' class='w-100 no-outline busca border-redonda tamanho-filtro px-2'></input>
            </div>

            <div class='mb-3'>
                <h5 class='montserrat verde'>Preço Máximo</h5>
                    <input type="number" min='0' class='w-100 no-outline busca border-redonda tamanho-filtro px-2'></input>
            </div>  
            <div class='mb-3'>
                <h5 class='montserrat verde'>Ordenar Por</h5>
                    <select class="w-100 no-outline busca border-redonda tamanho-filtro px-2">
                        <option>---------</option>
                        <option>Maior Preço</option>
                        <option>Menor Preço</option>
                        {/* <option>Populares</option> */}
                        <option>Lançamentos</option>
                        {/* <option>Promoções</option> */}
                    </select>
            </div>                 
        </div>           

        <div class="border-top-gray">
            <button onClick={setQuery} class="btn-verde mt-4 pull-right mr-5" id='btn-filtro'>
                <i class="fa fa-search mr-4"></i>
                Submit
            </button>
        </div>
    </div>
    )
}



export default Filtro;